// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore"
import {getFunctions} from "firebase/functions";
import {getStorage} from "firebase/storage";

import { getAuth } from "firebase/auth"
const firebaseConfig = {
    apiKey: "AIzaSyDvMjOL1uwjB_tkRmy8ZGheEmzCgqQ22is",
    authDomain: "project-vue-app.firebaseapp.com",
    projectId: "project-vue-app",
    storageBucket: "project-vue-app.firebasestorage.app",
    messagingSenderId: "634465227192",
    appId: "1:634465227192:web:6335c15d196c976e553f4d",
    measurementId: "G-7RDJNGWE2C"
};
// Initialize Firebase
// const appId = typeof __app_id !== 'undefined' ? __app_id : 'wedding-qr-auth';
// const initialToken = typeof __initial_auth_token !== 'undefined' ? __initial_auth_token : null;
const FireBaseApp = initializeApp(firebaseConfig);
const auth = getAuth(FireBaseApp);
const db = getFirestore(FireBaseApp, 'articles');

// const auth = getAuth(FireBaseApp);
// const googleAuthProvider = new GoogleAuthProvider()
console.log('jusqu ici tout va bien 0')

const functions = getFunctions(FireBaseApp, "us-central1");
const storage = getStorage(FireBaseApp);
export {FireBaseApp, db, auth, functions, storage}
